import PhotoArrows from '../src/PhotoArrows';
export default PhotoArrows;
